import React, { useState, useEffect } from 'react'
import { useAuth } from '../../context/AuthContext'
import { Flag, MoContainer, MoLink, MoSpan } from '../../Mo7/mo7UI'
import { cols, icons } from '../../services/design.sevice'
import { Version } from "../../services/data.service"
import { database } from '../../firebase'
const sidebarLinks = [
    { name: "Home", to: '/dashboard/home', icon: icons.ic_home },
    { name: "Announcements", to: '/dashboard/announcements', icon: icons.ic_case },
    { name: "Messages", to: '/dashboard/messages', icon: icons.ic_message },
    { name: "Notifications", to: '/dashboard/notifications', icon: icons.ic_bill },
    { name: "", to: '/home', icon: icons.ic_return_x2 },
]

export default function Sidebar() {
    const { signout, currentUser } = useAuth()
    const [open, setOpen] = useState(false)

    //rank
    const [{ rank, rankStyle }, setRank] = useState({
        rank: "Bronze", rankStyle: `  linear-gradient(
            -72deg,
            #ca7345,
            #ffdeca 16%,
            #ca7345 21%,
            #ffdeca 24%,
            #a14521 27%,
            #ca7345 36%,
            #ffdeca 45%,
            #ffdeca 60%,
            #ca7345 72%,
            #ffdeca 80%,
            #ca7345 84%,
            #732100
          );`
    })
    useEffect(() => {
        //get all stars
        return database.reviews.doc(currentUser.uid).get().then((doc) => {
            if (doc.exists) {
                let stars = 0;
                let myRank = {}
                Object.entries(database.formattedDoc(doc)?.list).map(([_, val]) => stars += val.stars)

                //calculate based on stars

                if (stars >= 0 && stars < 10) myRank = {
                    rank: "Bronze", rankStyle: `  linear-gradient(
                        -72deg,
                        #ca7345,
                        #ffdeca 16%,
                        #ca7345 21%,
                        #ffdeca 24%,
                        #a14521 27%,
                        #ca7345 36%,
                        #ffdeca 45%,
                        #ffdeca 60%,
                        #ca7345 72%,
                        #ffdeca 80%,
                        #ca7345 84%,
                        #732100
                      );`
                }
                else if (stars >= 10 && stars < 20) myRank = {
                    rank: "Silver", rankStyle: `  linear-gradient(
                        -72deg,
                        #dedede,
                        #ffffff 16%,
                        #dedede 21%,
                        #ffffff 24%,
                        #454545 27%,
                        #dedede 36%,
                        #ffffff 45%,
                        #ffffff 60%,
                        #dedede 72%,
                        #ffffff 80%,
                        #dedede 84%,
                        #a1a1a1
                      );` }
                else if (stars >= 20 && stars < 40) myRank = {
                    rank: "Golden", rankStyle: `  linear-gradient(
                    -72deg,
                    #ffde45,
                    #ffffff 16%,
                    #ffde45 21%,
                    #ffffff 24%,
                    #452100 27%,
                    #ffde45 36%,
                    #ffffff 45%,
                    #ffffff 60%,
                    #ffde45 72%,
                    #ffffff 80%,
                    #ffde45 84%,
                    #452100
                  );` }
                else if (stars >= 40) myRank = {
                    rank: "Platinum", rankStyle: `
                    linear-gradient(
                        -72deg,
                        #dedeff,
                        #ffffff 16%,
                        #dedeff 21%,
                        #ffffff 24%,
                        #555564 27%,
                        #dedeff 36%,
                        #ffffff 45%,
                        #ffffff 60%,
                        #dedeff 72%,
                        #ffffff 80%,
                        #dedeff 84%,
                        #555564
                      ); 
                   ` }

                //update in users collection
                setRank(myRank)
                database.ranks.doc(currentUser.uid).set({
                    rank: myRank.rank,
                    stars: stars,
                })

            } else {
                // doc.data() will be undefined in this case
                console.log("No such document review!");

            }
        }).catch((error) => {
            console.log("Error getting document:", error);
        });

    }, [currentUser.uid])

    //#region dom

    const domSidebarLinks = sidebarLinks.map((r, i) => {
        return <MoLink hvr="img{transform:scale(1.2) ;}" key={i} to={r.to} eff_hover_col={cols.green} col={cols.mainLight_1}>
            <MoContainer pos="relative" flex align="center" flow="hidden" w="12rem" h="3rem">
                <MoContainer place="center" pd={{ tb: 0, lr: 'calc((3.5rem - 20px) / 2)' }}>
                    <img width="20px" height="15px" src={r.icon} alt="" />
                </MoContainer >
                <MoContainer op={open ? 1 : 0} tra="opacity .3s;" >
                    {r.name}
                </MoContainer>
            </MoContainer>
        </MoLink>
    })
    //#endregion
    return (
        <MoContainer z="3" flex flex_dir_c b_r={{ tr: "1rem" }} flow="hidden" bg={cols.mainDark_1} pos="absolute" h="100%">
            {/* open ,close sidebar */}
            <MoContainer pos="absolute" z="1" onClick={() => setOpen(!open)} grid place="center" pd={{ t: "1rem" }} wh="3.5rem">
                <MoContainer pos="absolute" grid place="center" b_r={{ all: "1rem" }} eff_shdw={{ col: cols.main_purple }} w="30px" h="40px">
                    <MoContainer pos="absolute" op={open ? 1 : 0} tra="opacity .4s;">
                        <img src={icons.ic_unfold_less} height="18px" alt="" />
                    </MoContainer>
                    <MoContainer pos="absolute" op={!open ? 1 : 0} tra="opacity .4s;">
                        <img src={icons.ic_unfold_more} height="18px" alt="" />
                    </MoContainer>
                </MoContainer>
            </MoContainer>

            <MoContainer op={open ? 1 : 0} tra="opacity .3s;" pos='absolute' pos_dir={{ l: "2.5rem", t: "2.5rem" }} flex gap="2rem" flex_dir_c align="center" justify="center" >
                <MoContainer m_l=".5rem" eff_size={{ val: 1.2 }} bg_i={currentUser.photoURL} border={{ w: "2px", col: cols.mainLight_2 }} b_r={{ all: "12rem" }} wh="5rem" />
                <Flag bg_all={rankStyle} col={cols.mainDark_1} text={`${rank} Bolt`} h="1.5rem" w="fit-content" />
            </MoContainer>


            <MoContainer bg={cols.mainDark_2} pd={{ t: '1rem' }} b_r={{ tr: "1rem" }} flow="hidden" flex flex_dir_c m_t="auto" h="60%" tra="width ease-out .25s" w={open ? '12rem' : "3.5rem"} >

                {/* Link */}
                {domSidebarLinks}

                {/* logout */}
                <MoLink to="/home" m_t="auto" m_b="15px" hvr="img{transform:scale(1.2) ;}" col={cols.red} >
                    <MoContainer onClick={signout} pos="relative" flex align="center" flow="hidden" w="12rem" h="3rem">
                        <MoContainer place="center" pd={{ tb: 0, lr: 'calc((3.5rem - 25px) / 2)' }}>
                            <img width="25px" height="15px" src={icons.ic_exit} alt="" />
                        </MoContainer>
                        <MoContainer op={open ? 1 : 0} tra="opacity .3s;" >
                            Logout
                        </MoContainer>
                    </MoContainer>
                </MoLink>
            </MoContainer>

            {/* Version */}
            <MoContainer grid w="100%" h="15px" pd={{ l: "5px" }} pos_dir={{ b: 0 }} pos="absolute"><MoSpan f_size=".6rem" col='white'>v {Version}</MoSpan></MoContainer>
        </MoContainer>

    )
}
